module.exports = __webpack_public_path__ + "static/media/logo-invision.1015be2d.svg";